import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { Router } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { LazyLoadEvent } from 'primeng/api';
import { Dropdown } from "primeng/dropdown";
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver/src/FileSaver';
import * as moment from "moment";
import { maxYearFunction } from 'src/app/_helpers/utility';
import { PushNotificationService } from 'src/app/services/push-notification.service';
import { CategoryService } from 'src/app/services/category.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-push-notifications',
  templateUrl: './push-notifications.component.html',
  styleUrls: ['./push-notifications.component.scss'],
  providers: [MessageService, ConfirmationService]
})

export class PushNotificationsComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  errorMessage = '';
  statuses: any[];
  searchBy: any[];
  totalRecords: 0;
  pushNotificationList: any[] = [];
  public item: any[] = [];
  loading: boolean = true;
  paginationOption;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  calvalue: Date;
  ucalvalue: Date;
  dcalvalue: Date;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  downloadPushNotificationList: any;
  searchby;
  wdcalvalue;
  public hide: boolean = true;
  public sellerCsvFile;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId1", { static: false }) pDropDownId1: Dropdown;
  @ViewChild("pDropDownId2", { static: false }) pDropDownId2: Dropdown;
  @ViewChild("pDropDownId3", { static: false }) pDropDownId3: Dropdown;
  @ViewChild("pDropDownId4", { static: false }) pDropDownId4: Dropdown;
  pushNotificationTypes: any = [];
  pushNotificationModules: any = [];
  pushNotificationAppTypes: any = [];
  displayIconDialog: boolean = false;
  selectedIconUrl: string = '';

  constructor(private pushNotificationService: PushNotificationService, private router: Router, private messageService: MessageService, private confirmationService: ConfirmationService, private categoryService: CategoryService) { }

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.yearRange = this.minYear + ":" + maxYearFunction();
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];
    this.pushNotificationTypes = [
      { label: 'Push Notification', value: 'Push Notification' },
      { label: 'Website', value: 'Website' }
    ];

    // this.pushNotificationModules = [
    //   { label: 'Wallet', value: 'Wallet' },
    //   { label: 'FAP', value: 'FAP' },
    //   { label: 'Tournament', value: 'Tournament' },
    //   { label: 'Contest', value: 'Contest' },
    // ];

    this.pushNotificationAppTypes = [
      { label: 'Player', value: 'Player' },
      { label: 'Academy', value: 'Academy' }
    ];
    this.searchBy = [
      { label: 'Created On', value: "created_at" },
      { label: 'Last Modified On', value: "updated_at" }
    ];
    this.downloadFlg = false;
    //this.getwalletlist();
    // this.getCategory();
    this.getPushNotificationModules();
  }
  
  getPushNotificationModules() {
    const query = `?filterByParentCategory=pushNotificationModule`;
    this.categoryService.getCategoryList(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      const pushNotificationModules = data?.data?.items;
      pushNotificationModules.forEach(ele => {
        this.pushNotificationModules.push({ label: ele.name, value: ele.name });
      })
    })
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt.filter('', 'name', 'contains');
    this.dt.filter('', 'slug', 'contains');
    this.dt.filter('', 'description', 'contains');
    this.dt.filter('', 'notificationHeaderName', 'contains');
    this.dt.filter('', 'notificationIcon', 'contains');
    this.dt.filter('', 'created_at', 'dateIs');
    this.dt.filter('', 'createdby', 'contains');
    this.dt.filter('', 'updated_at', 'dateIs');
    this.dt.filter('', 'updatedby', 'contains');
    this.calvalue = null;
    this.ucalvalue = null;
    this.dcalvalue = null;
    this.wdcalvalue = null;
    this.pDropDownId1.clear(null);
    this.pDropDownId2.clear(null);
    this.pDropDownId3.clear(null);
    this.pDropDownId4.clear(null);
    if (this.pDropDownId1) {
      this.pDropDownId1.value = null;
    }
    if (this.pDropDownId2) {
      this.pDropDownId2.value = null;
    }
    if (this.pDropDownId3) {
      this.pDropDownId3.value = null;
    }
    if (this.pDropDownId4) {
      this.pDropDownId4.value = null;
    }
  }

  loadPushNotifications(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (event.filters != undefined && event.filters["name"] != undefined) {
      params += "&filterByName=" + event.filters["name"].value;
    }
    if (event.filters != undefined && event.filters["slug"] != undefined) {
      params += "&filterBySlug=" + event.filters["slug"].value;
    }
    if (event.filters != undefined && event.filters["status"] != undefined) {
      params += "&filterByStatus=" + event.filters["status"].value;
    }
    if (event.filters != undefined && event.filters["pushNotificationType"] != undefined) {
      params += "&filterByType=" + event.filters["pushNotificationType"].value;
    }
    if (event.filters != undefined && event.filters["description"] != undefined) {
      params += "&filterByDescription=" + event.filters["description"].value;
    }
    if (event.filters != undefined && event.filters["module"] != undefined) {
      params += "&filterByModule=" + event.filters["module"].value;
    }
    if (event.filters != undefined && event.filters["appType"] != undefined) {
      params += "&filterByAppType=" + event.filters["appType"].value;
    }
    if (event.filters != undefined && event.filters["notificationHeaderName"] != undefined) {
      params += "&filterByNotificationHeaderName=" + event.filters["notificationHeaderName"].value;
    }
    if (event.filters != undefined && event.filters["notificationIcon"] != undefined) {
      params += "&filterByNotificationIcon=" + event.filters["notificationIcon"].value;
    }
    if (event.filters != undefined && event.filters["created_at"] != undefined) {
      const createdAt = moment(event.filters["created_at"].value).format("YYYY-MM-DD");
      params += "&filterByCreatedAt=" + createdAt;
    }
    if (event.filters != undefined && event.filters["createdby"] != undefined) {
      params += "&filterByCreatedby=" + event.filters["createdby"].value;
    }
    if (event.filters != undefined && event.filters["updated_at"] != undefined) {
      const createdAt = moment(event.filters["updated_at"].value).format("YYYY-MM-DD");
      params += "&filterByUpdatedAt=" + createdAt;
    }
    if (event.filters != undefined && event.filters["updatedby"] != undefined) {
      params += "&filterByUpdatedby=" + event.filters["updatedby"].value;
    }

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.pushNotificationService.getAllPushNotification(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        console.log('API Response:', data);
        if (this.downloadFlg === true) {
          this.exportExcelSheet(data.data || data);
        } else {
          this.loading = false;
          // Handle both response structures: {data: {items, totalCount}} or {data: [...], totalCount}
          if (data.data && Array.isArray(data.data.items)) {
            this.pushNotificationList = data.data.items;
            this.totalRecords = data.data.totalCount;
          } else if (Array.isArray(data.data)) {
            this.pushNotificationList = data.data;
            this.totalRecords = data.totalCount;
          } else {
            this.pushNotificationList = [];
            this.totalRecords = 0;
          }
          console.log('Push Notification List:', this.pushNotificationList);
          console.log('Total Records:', this.totalRecords);
        }
      },
      err => {
        this.loading = false;
        this.errorMessage = err.error.message;
        console.error('API Error:', err);
      });
  }

  async findImageByBase(base, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].file === base) {
        index = i;
        break;
      }
    }
    return index;
  }


  func(prop, val) {
    var jsonStr = '{"' + prop + '":"' + val + '"}';
    return JSON.parse(jsonStr);
  }

  addNewPushNotification() {
    this.router.navigate(['/manage/push-notification/add']);
  }

  editPushNotification(id) {
    this.router.navigate(['/manage/push-notification/edit/' + id]);
  }

  deletePushNotification(data) {
    this.confirmationService.confirm({
    message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to delete this record ?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
      // ❌ Remove icons
    acceptIcon: '',
    rejectIcon: '' , 
      accept: () => {
        var disableStatus;
        if (data.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        var updatedata = '{"disable":' + disableStatus + '}';
        this.pushNotificationService.updatePushNotification(data.id, updatedata).pipe(takeUntil(this.destroy$)).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Push Notification Deleted', life: 3000 });
            setTimeout(()=>{
              this.loadPushNotifications(this.lastTableLazyLoadEvent);
            },2000);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.pushNotificationList.length; i++) {
      if (this.pushNotificationList[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }

  changeStatus(data) {
    this.confirmationService.confirm({
      // message: 'Are you sure you want to change the status of  ' + (this.titlecasePipe.transform(data.name)) + '?',
          message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to change this status ?
      </p>
    `,
 
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
      // ❌ Remove icons
    acceptIcon: '',
    rejectIcon: '' , 

      accept: () => {

        var updateData = '{"status":' + data.status + '}';
        this.pushNotificationService.updatePushNotification(data.id, updateData).pipe(takeUntil(this.destroy$)).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Push Notification Status Updated', life: 3000 });
            setTimeout(()=>{
              this.loadPushNotifications(this.lastTableLazyLoadEvent);
            },1000);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        this.loadPushNotifications(this.lastTableLazyLoadEvent);
      }
    });
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadPushNotifications(this.lastTableLazyLoadEvent);
  }

  exportExcelSheet(pushNotificationList) {
    var propertiesRemove = ['id', 'updatedby', 'description', 'disable', 'status', 'created_by', 'Modification_Date'];
    this.downloadPushNotificationList = pushNotificationList;
    this.downloadPushNotificationList.forEach(function (item) {
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.downloadPushNotificationList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, "Push_Notification");
    });
  }


  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  /**
   * Use to add more columns in the table.
  */
  addColumns() {
    this.hide = false;

  }

  /**
  * Use to remove more columns in the table.
  */
  removeColumns() {
    this.hide = true;
  }

  viewIconFullSize(iconUrl: string) {
    this.selectedIconUrl = iconUrl;
    this.displayIconDialog = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
